import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

function Card({
  actionButton,
  children,
  className,
  flush,
  footerLink,
  loading,
  subTitle,
  title,
  titlePath,
  titleSize
}) {
  if (loading) {
    return /*#__PURE__*/React.createElement("article", {
      className: cx("slds-card tds-card tds-card_loading", className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "slds-card__body"
    }, /*#__PURE__*/React.createElement("div", {
      role: "status",
      className: "slds-spinner slds-spinner_medium"
    }, /*#__PURE__*/React.createElement("span", {
      className: "slds-assistive-text"
    }, "Loading"), /*#__PURE__*/React.createElement("div", {
      className: "slds-spinner__dot-a"
    }), /*#__PURE__*/React.createElement("div", {
      className: "slds-spinner__dot-b"
    }))));
  }
  return /*#__PURE__*/React.createElement("article", {
    className: cx("slds-card tds-card", {
      "tds-card_flush": flush
    }, className)
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "slds-card__header slds-grid"
  }, /*#__PURE__*/React.createElement("header", {
    className: "slds-media slds-media_top slds-has-flexi-truncate slds-is-relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slds-media__body"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "slds-card__header-title"
  }, /*#__PURE__*/React.createElement("h2", {
    className: titleSize === "regular" ? "tds-text_bold" : `slds-text-heading_${titleSize || "medium"}`
  }, titlePath && /*#__PURE__*/React.createElement("a", {
    href: titlePath
  }, title), !titlePath && /*#__PURE__*/React.createElement("span", null, title)), subTitle && /*#__PURE__*/React.createElement("div", {
    className: "slds-text-title slds-m-top_xx-small"
  }, subTitle))), actionButton && /*#__PURE__*/React.createElement("div", {
    className: "slds-no-flex tds-card__action"
  }, actionButton()))), /*#__PURE__*/React.createElement("div", {
    className: "slds-card__body slds-card__body_inner"
  }, children), footerLink && footerLink.title && footerLink.href && /*#__PURE__*/React.createElement("footer", {
    className: "slds-card__footer"
  }, /*#__PURE__*/React.createElement("a", {
    className: "slds-card__footer-action",
    href: footerLink.href
  }, footerLink.title)));
}
Card.displayName = "Card";
Card.propTypes = {
  /**
   * Function that should return a `<button />` element.
   */
  actionButton: PropTypes.func,
  /**
   * Body contents of the card.
   */
  children: PropTypes.node,
  /**
   * CSS class name applied to the top-level `<article />` wrapper.
   */
  className: PropTypes.string,
  /**
   * Removes padding from the header, body, and footer.
   */
  flush: PropTypes.bool,
  /**
   * Object with `href` and  `title` strings to compose an `<a />` link.
   */
  footerLink: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string
  }),
  /**
   * Displays an empty card with a spinner.
   */
  loading: PropTypes.bool,
  /**
   * Subtitle.
   */
  subTitle: PropTypes.string,
  /**
   * Title within an `<h2 />` tag.
   */
  title: PropTypes.string,
  /**
   * Makes the title a link, if specified.
   */
  titlePath: PropTypes.string,
  /**
   * Title size variants.
   */
  titleSize: PropTypes.oneOf(["regular", "xx-small", "x-small", "small", "medium", "large"])
};
Card.defaultProps = {
  actionButton: null,
  children: null,
  className: null,
  flush: false,
  footerLink: null,
  loading: false,
  subTitle: null,
  title: null,
  titlePath: null,
  titleSize: null
};

export { Card as default };
